<template>
<div class="lang-page">
    <div class="lang">
        <div class="initImg">
            <span class="showLang" :style="{backgroundImage:'url(' + langList.logoImg + ')'}"></span>
            <!-- <span :style="{ color:iscolor }" class="text">{{ $t(langList.text) }}</span> -->
        </div>
        <div class="propllang">
            <div v-for="(item,index) in langArr" :key="index" @click="switchLang(item)" :class="{'active':item.lang == isLanguage }">
                <img :src="item.logoImg" alt width="26px" height="26px"/>
                <span>{{ $t(item.text) }}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
    export default {
        props:{
            iscolor:{
                type:String,
                required:false
            }
        },
        computed:{
            ...mapState({
                isLanguage: (state) => state.isLanguage,
            }),
            langArr(){
                return [
                    {
                        // logoImg: require("./img/lang/en_ffe40d5.png"),
                        logoImg: require("./img/lang/hi_25dd4b9.png"),
                        lang: "en_US",
                        text: "dialog.English",
                    },
                    {
                        logoImg: require("./img/lang/hi_25dd4b9.png"),
                        lang: "hi_IN",
                        text: "dialog.India",
                    },
                ];
            },
            langList() {
                if (this.isLanguage == "en_US") {
                    return { lang: "en_US", text: "dialog.English",logoImg: require("./img/lang/hi_25dd4b9.png") }
                } else if (this.isLanguage == "hi_IN") {
                    return { lang: "hi_IN",text: "dialog.India",logoImg: require("./img/lang/hi_25dd4b9.png"),}
                }
            }
        },
        methods:{
            ...mapMutations(["setIsLanguage"]),
            switchLang(item) {
                if(item.lang != this.isLanguage){
                    this.$Cookies.set("lang", item.lang);
                    this.$i18n.locale = item.lang;
                    this.setIsLanguage(item.lang);
                    this.$router.go(0);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.comonstyle{
    width:11px;
    height:6px;
    background-repeat: no-repeat;
    background-size: 100%;
    vertical-align:middle;
    background-position: center;
}
.lang-page{
    height:38px;
    line-height: 38px;
    .lang{
        line-height: 38px;
        height:100%;
        font-size:14px;
        position: relative;
        &:hover{
            .propllang{ display:block;}
        }
        div{
            position: relative;
            display:inline-block;
            color:#fff;
            cursor: pointer;
            width:100%;
        }     
        .propllang{
            display:none;
            width: 165px;
            // height: 120px;
            position: absolute;
            z-index:1;
            top:38px;
            right:-5px;
            text-align: left;
            font-weight: normal;
            padding:5px;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
            border-radius: 16px;
            background: linear-gradient(118.88deg, #474747 0%, #323631 100%);
            div{ 
                text-align: left;
                height: 42px;
                line-height: 42px;
                font-family: Roboto-Black;
                padding:0 5px;
                border-radius:10px;
                span{
                color: #fff;
                font-weight: bold;
                padding-left:10px;
               };
               &:hover{
                    background: #FFFFFF19;
               }
            }
            .active{
                background: #FFFFFF19;
                &::after{
                    content: '';
                    margin-left:10px;
                    display: inline-block;
                    // background-image:url('./img/lang/gou.png');
                    width:17px;
                    height:13px;
                    background-size: 100%;
                }
                span{ color: #F3B867; }
            }
           
        }
        .initImg{
            display:flex;
            align-items: center;
            font-weight: 550;
            font-family: Roboto-Bold;
            color: #ffffff;
            height: 38px;

            &:hover{
                &::after{ transform: rotate(180deg);}
            }
            .showLang{
              display:inline-block;
              @extend .comonstyle;
              width:24px;
              height:24px;
            //   margin-top:3px;
            }
            .text{  margin:0 8px;}
            // &::after{
            //     content: '';
            //     background-image:url('./img/lang/top_more.png');
            //     transition: all 300ms;
            //     @extend .comonstyle;
            // }
        }
    
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/build902/components/common/languages.vue